import Keycloak from "keycloak-js";

let keycloak = null;

if (keycloak == null) {
    keycloak = new Keycloak({
        url: process.env.REACT_APP_API_KEYCLOAK_URL,
        realm: process.env.REACT_APP_KEYCLOAK_REALM,
        clientId: "cloud-ecr"
    });
}

export default keycloak;